// Collapsible content
const toggleContainer = Array.from(
    document.getElementsByClassName('toggles-container')
  );
  const allToggles = document.getElementsByClassName('toggle');
  const allContent = Array.from(document.getElementsByClassName('content'));
  
  const displaySection = selectedToggle => {
    const toggleIsActive = selectedToggle.classList.contains('active');
    const expandableContent = selectedToggle.nextElementSibling;
  
    Array.from(allToggles).map(toggle => {
      toggle.className = toggle.className.replace(' active', '');
    });
  
    allContent.map(content => {
      content.style.maxHeight = null;
    });
  
    if (toggleIsActive) {
      selectedToggle.className = 'toggle';
    } else {
      selectedToggle.className += ' active';
      expandableContent.style.maxHeight = expandableContent.scrollHeight + 'px';
    }
  };
  
  toggleContainer.forEach(container => {
    container.addEventListener('click', e => {
      const selectedToggle = e.target;
  
      if (e.target.tagName === 'BUTTON') {
        displaySection(selectedToggle);
      }
    });
  });



// $('.js-view-more').on('click', function(event) {
//     let that = this;
//     $('.hide-answer').each(function(){        
//         if($(this).css('display') == 'block' && $(that).closest('.js-hide-show').find('.hide-answer')[0] != this) {
//             $(this).slideToggle();
            
//             $(this).closest('.js-view-more').toggleClass('active');
            
//             $(this).closest('.js-hide-show').find('.icon-plus-sign').removeClass('hide-icon');
//             $(this).closest('.js-hide-show').find('.icon-minus-sign').addClass('hide-icon');
//         }
//     });
// });

// $('.js-view-more').on('click', function(event) {
//     if($(this).closest('.js-hide-show').find('.icon-plus-sign').hasClass('hide-icon')) {
//         $(this).closest('.js-hide-show').find('.icon-plus-sign').removeClass('hide-icon');
//         $(this).closest('.js-hide-show').find('.icon-minus-sign').addClass('hide-icon');
//     } else {
//         $(this).closest('.js-hide-show').find('.icon-plus-sign').addClass('hide-icon');
//         $(this).closest('.js-hide-show').find('.icon-minus-sign').removeClass('hide-icon');
//     }

//     $(this).closest('.js-hide-show').find('.hide-answer').slideToggle();
//     $(this).toggleClass('active');
// });